import React, { useEffect, useState } from "react";
import Header from "../common/Header";
import $ from "jquery";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import useAuth from "../../hooks/useAuth";
import moment from "moment";
import Toastify from "../common/Toastify";
import { GETREQUEST, POSTREQUEST } from "../helpers/ServiceRequest";
import { generateInvoicePdf } from "../Pdfs/invoice";
import { formatPrice } from "../helpers/common";

function AmendInvoice() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [customerDetailsObj, setCustomerDetailsObj] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);
  const [orderDetails, setOrderDetails] = useState([]);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [StandardRebate, setStandardRebate] = useState(0);
  const [crates, setCrates] = useState([]);
  const [units, setUnits] = useState([]);
  const [agents, setAgents] = useState([]);
  const { user } = useAuth();


  useEffect(() => {
    const fetchData = async () => {
      let commanURL = process.env.REACT_APP_API_URL + "/get-comman-all-for-product";
      let response = await GETREQUEST(commanURL, user.jwtToken);
      if (response?.data) {
        let containersList = [];
        response.data.containers.forEach((item) => {
          containersList = [...containersList, { label: item.TypeInCode, value: item.ContainerID, ...item }];
        });

        containersList.sort((a, b) => {
          const numA = parseInt(a.label);
          const numB = parseInt(b.label);

          if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB;
          } else if (!isNaN(numA)) {
            return -1;
          } else if (!isNaN(numB)) {
            return 1;
          } else {
            return a.TypeInCode.localeCompare(b.TypeInCode);
          }
        });
        setCrates(containersList);

        let unitList = [];
        response.data.units.forEach((item) => {
          unitList = [...unitList, { label: item.UnitName, value: item.UnitID, ...item }];
        });
        setUnits(unitList);

        let agentList = [];
        response.data.agent.forEach((item) => {
          agentList = [...agentList, { label: item.AgentCode, value: item.AgentID, ...item }];
        });
        setAgents(agentList);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });

  useEffect(() => {
    getInvoice(id)
  }, [id]);

  const CustomOptionAgent = (props) => {
    return (

      <div
        className=""
        style={{
          background: props.isFocused
            ? '#01B1E3'
            : props.isSelected
              ? 'rgb(54, 179, 126)'
              : "#fff", color: "gray", zIndex: 1, padding: " 8px 12px", cursor: "default", display: "block", fontSize: "inherit", width: "100%"
        }}
        {...props.innerProps}
        ref={props.innerRef}
      >
        {props.label}
      </div>
    )
  }

  const handleInputChange = (index, key, value) => {
    setOrderDetails(prevOrderDetails => {
      const updatedOrderDetails = [...prevOrderDetails];
      updatedOrderDetails[index][key] = value;
      return updatedOrderDetails;
    });
  }

  const handleCrateChange = (e, index) => {
    setOrderDetails(prevOrderDetails => {
      const updatedOrderDetails = [...prevOrderDetails];
      updatedOrderDetails[index]['ContainerID'] = e.value;
      updatedOrderDetails[index]['ContainerName'] = crates.find(crate => crate.ContainerID == e.value).TypeInCode || '';
      return updatedOrderDetails
    })
  }

  const calculateProfit = (index, buyPrice, sellPrice) => {
    if (buyPrice > 0 && sellPrice > 0) {
      buyPrice = parseFloat(buyPrice);
      sellPrice = parseFloat(sellPrice);
      let profit = 100 - (buyPrice / sellPrice * 100)
      profit = profit ? parseFloat(profit).toFixed(2) : 0;
      setOrderDetails(prevOrderDetails => {
        const updatedOrderDetails = [...prevOrderDetails];
        updatedOrderDetails[index]['Profit'] = profit;
        return updatedOrderDetails;
      });
    }
  }

  const calculateProfitPercentage = () => {
    if (orderDetails && orderDetails.length > 0) {
      let totalSalesPrice = 0;
      let totalBuyPrice = 0;
      orderDetails.map((item) => {
        totalSalesPrice += item.ExtSell ? parseFloat(item.ExtSell) : 0
        totalBuyPrice += item.ExtBuy ? parseFloat(item.ExtBuy) : 0
      })
      const totalProfit = totalSalesPrice - totalBuyPrice;
      let result = 0;
      if (totalProfit && totalSalesPrice)
        result = totalProfit / totalSalesPrice
      return isNaN(result) ? 0 : (result * 100).toFixed(2)
      const profitPercentage = (totalProfit / totalSalesPrice) * 100;
      return isNaN(profitPercentage) ? 0 : profitPercentage.toFixed(2) + '%';
    }
    else
      return 0;
  }

  const calculateRRPPercentage = () => {
    if (orderDetails && orderDetails.length > 0) {
      let totalExtRRP = 0;
      let totalSalesPrice = 0;
      orderDetails.map((item) => {
        totalSalesPrice += item.ExtSell ? parseFloat(item.ExtSell) : 0
        totalExtRRP += item.ExtRRP ? parseFloat(item.ExtRRP) : 0
      })
      let result = 0;
      if (totalSalesPrice && totalExtRRP)
        result = 100 - (totalSalesPrice * 100 / totalExtRRP)
      return isNaN(result) ? 0 : (result * 100).toFixed(2)
    }
    else
      return 0;
  }

  const calculateTtlProd = (index, qty, count, sellPrice, buyPrice, RRP, isIgnoreCrate = false) => {
    if (sellPrice > 0 && buyPrice > 0) {
      buyPrice = parseFloat(buyPrice);
      sellPrice = parseFloat(sellPrice);
      count = count && count > 0 ? count : 1;
      let value = isIgnoreCrate ? count : qty * count;
      let extSell = value * sellPrice;
      let extBuy = value * buyPrice;
      let extRRP = value * RRP;
      setOrderDetails(prevOrderDetails => {
        const updatedOrderDetails = [...prevOrderDetails];
        updatedOrderDetails[index]['ExtSell'] = extSell ? extSell.toFixed(2) : 0;
        updatedOrderDetails[index]['ExtBuy'] = extBuy;
        updatedOrderDetails[index]['ExtRRP'] = extRRP;
        return updatedOrderDetails;
      });

      if (sellPrice > 0 && RRP > 0) {
        let RetailPC = 100 - (sellPrice / RRP * 100)
        setOrderDetails(prevOrderDetails => {
          const updatedOrderDetails = [...prevOrderDetails];
          updatedOrderDetails[index]['RetailPC'] = RetailPC ? RetailPC.toFixed(2) : 0;
          return updatedOrderDetails;
        });
      }
    }
  }

  const calculateTotalTtlProd = () => {
    if (orderDetails && orderDetails.length > 0) {
      let total = 0;
      orderDetails.map((item) => {
        if (item.ExtSell)
          total += parseFloat(item.ExtSell)
      })
      return total.toFixed(2);
    }
    else
      return 0;
  }

  const getupdatedOrderValues = (item) => {
    const GSTRATE = 10;
    // Update Total Rebate Amt 

    //Rebate Amount = Standard Rebate * Extended Sell Price
    let totalRebate = 0;
    let ele = item;

    let rebateAmt = (StandardRebate * ele.ExtSell) / 100
    totalRebate += rebateAmt;

    let GSTOnSellAmt = 0;
    let GSTOnBuyAmt = 0;
    let GSTPaid = 0;
    if (ele.ProductGST) {
      GSTOnSellAmt = (ele.ExtSell - rebateAmt) / (GSTRATE + 1);
      GSTOnBuyAmt = ele.ExtBuy / (GSTRATE + 1)
    }

    if (GSTRATE && GSTOnBuyAmt > 0) {
      GSTPaid = ele.ExtBuy / (GSTRATE + 1) * (GSTRATE / 100);
    }

    // Update Crates Values 
    const CrateValue = ele.Qty * ele.ContainerValue;
    const CrateHire = ele.Qty * ele.ReturnValue;
    const CrateGST = (CrateValue - CrateHire) * (GSTRATE / 100);

    // Update Profit
    let profit = 0;
    if (ele.ExtSell > 0) {
      profit = 100 - ((ele.ExtBuy - GSTOnBuyAmt) * 100 / (ele.ExtSell - GSTOnSellAmt))
    }

    ele.CrateValue = CrateValue || 0;
    ele.CrateHire = CrateHire || 0;
    ele.CrateGST = Math.round(CrateGST * 100) / 100 || 0;
    ele.GSTAmount = Math.round(GSTOnSellAmt * 100) / 100;
    ele.GSTPaid = Math.round(GSTPaid * 100) / 100;
    ele.RebateAmount = Math.round(rebateAmt * 100) / 100;
    ele.NetExtBuy = Math.round((ele.ExtBuy - GSTOnBuyAmt) * 100) / 100;
    ele.NetExtSell = Math.round((ele.ExtSell - ele.GSTAmount) * 100) / 100;
    ele.Profit = Math.round(profit * 100) / 100;

    // item.RebatePC = StandardRebate;
    // item.RebateAmt = totalRebate;

    return ele;
  }

  const saveBulkOrder = async (isSave = true) => {
    let updateInvoiceURL = process.env.REACT_APP_API_URL + `/amend-invoice`;

    const updateInvoiceData = {
      OrderID: invoiceData.OrderID,
      OrderDate: invoiceData.OrderDate,
      PurchaseOrder: invoiceData.PurchaseOrder,
      DeliveryInstructions: invoiceData.DeliveryInstructions,
      OrderNotes: invoiceData.OrderNotes,
      CustomerID: invoiceData.CustomerID,
      OrderStatus: 'I',
      InvoiceDate: invoiceData.InvoiceDate,
      InvoiceNo: invoiceData.InvoiceNo,
      OrderDetails: []
    };

    const updatedOrderDetails = await Promise.all(orderDetails.map(async (OrderItem) => {
      const updatedOrderDetail = {
        OrderID: OrderItem.OrderID,
        ODID: OrderItem.ODID,
        ProductID: OrderItem.ProductID,
        ProductCode: OrderItem.ProductCode,
        ProductGST: OrderItem.tblProduct.GST,
        UnitID: OrderItem.UnitID,
        ClassName: OrderItem.ClassName,
        SizeName: OrderItem.SizeName,
        BuyPrice: parseFloat(OrderItem.BuyPrice),
        SellPrice: parseFloat(OrderItem.SellPrice),
        Profit: parseFloat(OrderItem.Profit),
        Count: parseFloat(OrderItem.Count),
        BPException: OrderItem.BPException != null ? Boolean(OrderItem.BPException) : false,
        CntException: OrderItem.CntException != null ? Boolean(OrderItem.CntException) : false,
        AgentID: OrderItem.AgentID,
        ProductName: OrderItem.ProductName,
        Qty: parseFloat(OrderItem.Qty),
        ExtBuy: parseFloat(OrderItem.ExtBuy),
        ExtSell: parseFloat(OrderItem.ExtSell),
        IgnoreCrate: OrderItem.IgnoreCrate,
        ContainerID: OrderItem.ContainerID,
        ContainerValue: crates.find(crate => crate.ContainerID == OrderItem.ContainerID)?.ContainerValue,
        ReturnValue: crates.find(crate => crate.ContainerID == OrderItem.ContainerID)?.ReturnValue,
        RRP: parseFloat(OrderItem.RRP || 0),
        ExtRRP: parseFloat(OrderItem.ExtRRP),
        RetailPC: parseFloat(OrderItem.RetailPC),
        tblContainer: crates.find(crate => crate.ContainerID == OrderItem.ContainerID),
        tblProduct: OrderItem.tblProduct
      };

      const updateOrderItem = await getupdatedOrderValues(updatedOrderDetail);
      return { ...updatedOrderDetail, ...updateOrderItem };
    }));

    updateInvoiceData.OrderDetails = updatedOrderDetails;
    updateInvoiceData.isUpdateCustomerDetails = null;
    if (StandardRebate && customerDetailsObj?.StandardRebate !== parseFloat(StandardRebate)) {
      updateInvoiceData.isUpdateCustomerDetails = {
        'StandardRebate': parseFloat(StandardRebate)
      }
    }
    setMessageType('')
    setMessage('')
    if (isSave) {
      let response = await POSTREQUEST(updateInvoiceURL, updateInvoiceData, user.jwtToken);
      if (response?.data) {
        if (response.data.success) {
          setMessage(response.data.message);
          setMessageType('success');
        } else {
          setMessage(response.data.message);
          setMessageType('error');
        }
      } else {
        setMessage(response?.error?.message || 'Failed to amend invoice !!');
        setMessageType('error');
      }
    } else {
      updateInvoiceData['tblOrderDetails'] = updatedOrderDetails;
      updateInvoiceData['tblCustomer'] = customerDetailsObj;
      delete updateInvoiceData.OrderDetails;
      await generateInvoicePdf(updateInvoiceData);
    }
  }

  const getInvoice = async(id) => {
    if (id) {
      const InvoiceURL = `${process.env.REACT_APP_API_URL}/get-invoice/${id}`;
      let response = await GETREQUEST(InvoiceURL, user.jwtToken);
      if (response?.data) {
        let data = response.data
        setOrderDetails(data?.tblOrderDetails)
        setCustomerDetailsObj(data?.tblCustomer)
        setStandardRebate(data?.tblCustomer?.StandardRebate)
        delete data.tblOrderDetails;
        delete data.tblCustomer;
        setInvoiceData(data);
      } else {
        setMessageType('error');
        setMessage(response?.error?.message || 'Something went wrong !!')
      }
    }
  }

  return (
    <React.Fragment>
      <Header />
      {message && <Toastify message={message} type={messageType} />}
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4 overflow-hidden table-listing">
          <div className="table-elements">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/all-invoices"
                    className="text-decoration-none text-primary"
                  >
                    Invoices
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  Amend Invoice
                </li>
              </ol>
            </nav>
          </div>

          <div className="card border-bottom-0">
            <div className="card-header bg-white d-flex align-items-center justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap">
              <h1 className="title-semibold fs-24 mb-xl-0 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                Amend Invoice
              </h1>
            </div>
            <div className="card-header bg-white d-flex align-items-lg-center justify-content-between cpx-20 cpy-14 flex-nowrap">
              <div className="filter-elements d-flex align-items-center justify-content-around w-100">
                <div className="flex-nowrap mb-lg-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Invoice Date
                  </label>
                  <input type="text"
                    className="form-control input-sm"
                    value={moment(invoiceData?.InvoiceDate).format('MM/DD/YYYY')}
                    disabled
                  />
                </div>
                <div className="flex-nowrap mb-lg-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Buyer Code
                  </label>
                  <input type="text"
                    className="form-control input-sm"
                    value={customerDetailsObj?.BuyerCode}
                    disabled
                  />
                </div>
                <div className="flex-nowrap mb-lg-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Customer Code
                  </label>
                  <input type="text"
                    className="form-control input-sm"
                    value={customerDetailsObj?.CustomerCode}
                    disabled
                  />
                </div>
                <div className="flex-nowrap mb-lg-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Customer Contact
                  </label>
                  <input type="text"
                    className="form-control input-sm"
                    value={customerDetailsObj?.CustomerContact}
                    disabled
                  />
                </div>
                <div className="flex-nowrap mb-lg-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Phone Number
                  </label>
                  <input type="text"
                    className="form-control input-sm"
                    value={customerDetailsObj?.CustomerContact}
                    disabled
                  />
                </div>
                <div className="flex-nowrap mb-lg-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Fax Number:
                  </label>
                  <input type="text"
                    className="form-control input-sm"
                    value={customerDetailsObj?.FaxNumber}
                    disabled
                  />
                </div>
                <div className="flex-nowrap mb-lg-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Rebate %:
                  </label>
                  <input type="text"
                    className="form-control input-sm"
                    value={StandardRebate}
                    onChange={(e) => setStandardRebate(e.target.value)}
                  />
                </div>
                <div className="flex-nowrap mb-lg-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Invoice Note:
                  </label>
                  <input type="text"
                    className="form-control input-sm"
                    disabled
                  //value={customerDetailsObj?.customerContact}
                  />
                </div>
              </div>
              <div></div>
            </div>
            <div className="card-body p-4 border-bottom">
              <div className="card-table table-responsive">
                <table className="table table-form">
                  <thead>
                    <tr>
                      <td scope="col" className="width-lg-4">
                        Qty
                      </td>
                      <td scope="col" className="width-lg-6">
                        Unit
                      </td>
                      <td scope="col" className="width-lg-6">
                        Crate
                      </td>
                      <td scope="col" className="width-lg-16">Product Name</td>
                      <td scope="col" className="width-lg-5">
                        Agent
                      </td>
                      <td scope="col" className="width-lg-4">
                        Count
                      </td>
                      <td scope="col" className="width-lg-1 px-2">
                        t
                      </td>
                      <td scope="col" className="width-lg-5">
                        Sell Price
                      </td>
                      <td scope="col" className="width-lg-5">
                        Buy Price
                      </td>
                      <td scope="col" className="width-lg-5">
                        % Profit
                      </td>
                      <td scope="col" className="width-lg-5">
                        Ext Sell
                      </td>
                      <td scope="col" className="width-lg-5">
                        Ext Buy
                      </td>
                      <td scope="col" className="width-lg-5">
                        RRP/Kg
                      </td>
                      <td scope="col" className="width-lg-6">
                        Ret.Gp
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {orderDetails.length > 0 && orderDetails.map((orderDetailItem, index) => {
                      return (<tr key={index + 1} className="custom-space">
                        <td>
                          <input
                            type="text"
                            className="form-control input-sm text-end"
                            placeholder="Qty"
                            onChange={(e) => setOrderDetails(prevOrderDetails => {
                              const updatedOrderDetails = [...prevOrderDetails];
                              updatedOrderDetails[index]['Qty'] = formatPrice(e.target.value);
                              return updatedOrderDetails
                            })}
                            value={orderDetailItem.Qty}
                          />
                        </td>
                        <td>
                          <Select
                            className="input-sm"
                            defaultValue={"Select Unit"}
                            value={units.find(unit => unit.UnitID == orderDetailItem.UnitID) || ''}
                            options={units}
                            placeholder="Select Unit"
                            onChange={(e) => setOrderDetails(prevOrderDetails => {
                              const updatedOrderDetails = [...prevOrderDetails];
                              updatedOrderDetails[index]['UnitID'] = e.value;
                              return updatedOrderDetails
                            })}
                            components={{ Option: CustomOptionAgent }}
                          ></Select>
                        </td>
                        <td>
                          <Select
                            className="input-sm"
                            defaultValue={"Select Crate"}
                            value={crates.find(crate => crate.ContainerID == orderDetailItem.ContainerID) || ''}
                            options={crates}
                            placeholder="Select Crate"
                            onChange={(e) => handleCrateChange(e, index)}
                            components={{ Option: CustomOptionAgent }}
                          ></Select>

                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control input-sm input-width-359"
                            placeholder="Product Name"
                            value={orderDetailItem.ProductName}
                            readOnly

                          />
                        </td>

                        <td>
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder="Agent Name"
                            value={agents.find(agent => agent.AgentID == orderDetailItem.AgentID)?.label || ''}
                            readOnly

                          />
                          {/* <Select
                            className="input-sm input-width-90"
                            defaultValue={"Select Agent"}
                            value={agents.find(agent => agent.AgentID == orderDetailItem.AgentID) || ''}
                            options={agents}
                            placeholder="Select Agent"
                            onChange={(e) => setOrderDetails(prevOrderDetails => {
                              const updatedOrderDetails = [...prevOrderDetails];
                              updatedOrderDetails[index]['AgentID'] = e.value;
                              return updatedOrderDetails
                            })}
                            components={{ Option: CustomOptionAgent }}
                            disabled
                          ></Select> */}
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control input-sm text-end"
                            placeholder="0"
                            value={orderDetailItem.Count}
                            onChange={(e) => {
                              setOrderDetails(prevOrderDetails => {
                                const updatedOrderDetails = [...prevOrderDetails];
                                updatedOrderDetails[index]['Count'] = e.target.value;
                                return updatedOrderDetails
                              })
                            }}
                            onBlur={(e) => {
                              calculateTtlProd(index, orderDetailItem.Qty, e.target.value, orderDetailItem.SellPrice, orderDetailItem.BuyPrice, orderDetailItem.RRP, orderDetailItem.IgnoreCrate)
                            }}
                          />
                        </td>
                        <td valign="middle">
                          <input
                            type="checkbox"
                            className="form-check-input d-flex mx-auto"
                            checked={orderDetailItem.IgnoreCrate}
                            onChange={(e) => {
                              setOrderDetails(prevOrderDetails => {
                                const updatedOrderDetails = [...prevOrderDetails];
                                updatedOrderDetails[index]['IgnoreCrate'] = e.target.checked;
                                return updatedOrderDetails
                              });
                              calculateTtlProd(index, orderDetailItem.Qty, orderDetailItem.Count, orderDetailItem.SellPrice, orderDetailItem.BuyPrice, orderDetailItem.RRP, e.target.checked)
                            }}
                          />
                        </td>
                        <td>
                          <div className="position-relative input-icon">
                            <input
                              type="text"
                              className="form-control input-sm text-end ps-4"
                              placeholder="0.00"
                              onChange={(e) => handleInputChange(index, 'SellPrice', e.target.value)}
                              onBlur={(e) => {
                                calculateProfit(index, orderDetailItem.BuyPrice, e.target.value);
                                calculateTtlProd(index, orderDetailItem.Qty, orderDetailItem.Count, e.target.value, orderDetailItem.BuyPrice, orderDetailItem.RRP, orderDetailItem.IgnoreCrate)
                              }}
                              value={orderDetailItem.SellPrice || ''}
                            />
                            <span className="text-lite cps-10 fs-14">$</span>
                          </div>
                        </td>

                        <td>
                          <div className="position-relative input-icon">
                            <input
                              type="text"
                              placeholder="0.00"
                              className="form-control input-sm text-end ps-4"
                              onChange={(e) => handleInputChange(index, 'BuyPrice', e.target.value)}
                              onBlur={(e) => {
                                calculateProfit(index, e.target.value, orderDetailItem.SellPrice)
                                calculateTtlProd(index, orderDetailItem.Qty, orderDetailItem.Count, orderDetailItem.SellPrice, e.target.value, orderDetailItem.RRP, orderDetailItem.IgnoreCrate)
                              }}
                              value={orderDetailItem.BuyPrice || ''}
                            />
                            <span className="text-lite cps-10 fs-14">$</span>
                          </div>
                        </td>

                        <td>
                          <div className="position-relative input-icon">
                            <input
                              type="text"
                              className="form-control input-sm text-end ps-4"
                              value={orderDetailItem.Profit}
                              readOnly
                            />
                            <span className="text-lite cps-10 fs-14">$</span>
                          </div>
                        </td>
                        <td>
                          <div className="position-relative input-icon">
                            <input
                              type="text"
                              className="form-control input-sm text-end ps-4"
                              value={orderDetailItem.ExtSell}
                              readOnly
                            />
                            <span className="text-lite cps-10 fs-14">$</span>
                          </div>
                        </td>
                        <td>
                          <div className="position-relative input-icon">
                            <input
                              type="text"
                              className="form-control input-sm text-end ps-4"
                              value={orderDetailItem.ExtBuy}
                              readOnly
                            />
                            <span className="text-lite cps-10 fs-14">$</span>
                          </div>
                        </td>
                        <td className="text-center">
                          <div className="position-relative input-icon">
                            <input
                              type="text"
                              className="form-control input-sm text-end ps-4"
                              value={orderDetailItem.RRP}
                              onChange={(e) => handleInputChange(index, 'RRP', e.target.value)}
                              onBlur={(e) => {
                                calculateTtlProd(index, orderDetailItem.Qty, orderDetailItem.Count, orderDetailItem.SellPrice, orderDetailItem.BuyPrice, e.target.value, orderDetailItem.IgnoreCrate)
                              }}
                            />
                            <span className="text-lite cps-10 fs-14">$</span>
                          </div>
                        </td>
                        <td className="text-center">
                          <div className="position-relative input-icon">
                            <input
                              type="text"
                              className="form-control input-sm text-end ps-4"
                              value={orderDetailItem.RetailPC}
                              readOnly
                            />
                          </div>
                        </td>
                      </tr>)
                    })}

                  </tbody>
                </table>

              </div>
              <div className="spacer-sm-5"></div>
              <div className="row d-flex justify-content-between pb-3">
                <div className="col-md-1 d-flex">
                  <label className="p-1">
                    Items:
                  </label>
                  <input
                    type="text"
                    className="form-control input-sm text-end ps-4 input-width-110"
                    value={orderDetails ? orderDetails.length : 0}
                    readOnly
                  />
                </div>
                <div className="col-md-3 d-flex gap-3">
                  <div className="position-relative input-icon">
                    <input
                      type="text"
                      placeholder="0."
                      className="form-control input-sm text-end ps-4 input-width-110"
                      value={calculateTotalTtlProd()}
                      readOnly
                    />
                    <span className="text-lite cps-10 fs-14">$</span>
                  </div>
                  <div className="position-relative input-icon">
                    <input
                      type="text"
                      className="form-control input-sm text-end ps-4"
                      value={calculateProfitPercentage()}
                      readOnly
                    />
                    <span className="text-lite cps-10 fs-14">%</span>
                  </div>
                  <div className="position-relative input-icon">
                    <input
                      type="text"
                      className="form-control input-sm text-end ps-4 input-width-110"
                      value={calculateRRPPercentage()}
                      readOnly
                    />
                    <span className="text-lite cps-10 fs-14">%</span>
                  </div>
                </div>

              </div>
              <div className="row">
                <div className="col d-flex flex-column justify-content-between align-items-end mt-4 mt-lg-0">

                  <div className="d-flex">
                    <button onClick={() => saveBulkOrder(false)}
                      disabled={orderDetails.length > 0 ? false : true}
                      type="button"
                      className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                    >
                      Preview
                    </button>
                    <button type="button"
                      className="btn btn-md btn-secondary text-white d-flex align-items-center px-4 fw-medium rounded-3 mx-2"
                      onClick={() => saveBulkOrder()}
                    >
                      Save
                    </button>
                    <button type="button"
                      onClick={() => { navigate("/veg-art") }}
                      className="btn btn-md btn-secondary text-white d-flex align-items-center px-4 fw-medium rounded-3"
                    >
                      Exit
                    </button>
                  </div>
                  <div></div>
                </div>
              </div>

              {!message && <div className="text-center"><span className='text-danger'>Kindly Save the Data before Exit Otherwise Data will be lost</span></div>}
              <div className="row">

                <div className="col d-flex justify-content-end align-items-end">


                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default AmendInvoice;
